import {Button, DialogTitle, Zoom} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import React from "react";
import {observer} from "mobx-react";
import TaskAltIcon from '@mui/icons-material/TaskAlt';

export const ReportSentDialog = observer(({isOpen, setIsOpen}) => {
    return (
        <Dialog
            open={isOpen}
            onClose={() => setIsOpen(false)}
            TransitionComponent={Zoom}
            className='translate-popup'
        >
            <DialogTitle className='popup-header'>
                <TaskAltIcon className='success-icon'/>
                <div>{"Response submitted"}</div>
            </DialogTitle>
            <DialogContent>
                <DialogContentText style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                    <div> <span
                        className='popup-text'>{'Thank you for reporting the issue. Our system admins have'}</span>
                    </div>
                    <div><span className='popup-text'>{'received your message and will get back to you shortly.'}</span></div>
                </DialogContentText>
            </DialogContent>
            <DialogActions className='footer-buttons'>
                <Button
                    className='confirm-button'
                    variant="contained"
                    onClick={() => setIsOpen(false)}>
                    {'Ok'}
                </Button>
            </DialogActions>
        </Dialog>
    )
})